exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1FgNhbiRqovsd1Kt2GzMyY{padding-top:.5rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"__placeholder": "_1FgNhbiRqovsd1Kt2GzMyY"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/StudentCardProfile/style.postcss
// module id = 1322
// module chunks = 0